import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { SidebarComponent } from '@easyfo/toolbar';

if (environment.production) {
  enableProdMode();

  console.warn(`🚨 Console output is disabled on production!`);
  console.log = function (): void { };
  console.debug = function (): void { };
  console.warn = function (): void { };
  console.info = function (): void { };

  setInterval(() => {
    debugger;
  }, 1000);
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

window.addEventListener("contextmenu", e => {
  SidebarComponent.popupMenu(e)
});